import UserManager from '../../userManager';

export const SignoutCallback = () => {
    UserManager.signoutRedirectCallback().then(user => {
        window.location.href = "/";
    })

	  return null;
}
